import { render, staticRenderFns } from "./choix-personnage.vue?vue&type=template&id=61dfe51e&"
import script from "./choix-personnage.vue?vue&type=script&lang=js&"
export * from "./choix-personnage.vue?vue&type=script&lang=js&"
import style0 from "./choix-personnage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports